import React from 'react';

const LogoutPage = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-8">
      <h2 className="text-2xl font-bold text-center text-gray-900 mb-6">Logged Out</h2>
      <p className="text-center text-gray-600">You have been logged out successfully.</p>
    </div>
  );
};

export default LogoutPage;
